import { Autocomplete, Paper, TextField } from '@mui/material';

import { inputStyles, listboxStyles, paperStyles } from './styles';
import { SelectorProps } from './types';
import { SelectorChip } from './ui/SelectorChip';
import { SelectorOptionItem } from './ui/SelectorOption';

export const Selector = <T extends string>({
  value,
  onChange,
  options,
  placeholder = 'Выберите элементы',
  loading = false,
  noOptionsText = 'Элементы не найдены',
  loadingText = 'Загрузка...',
  onInputChange,
  getOptionLabel = (option) => option.label,
  isOptionEqualToValue = (option, val) => option.id === val.id,
}: SelectorProps<T>) => {
  return (
    <Autocomplete
      multiple
      size="small"
      options={options}
      getOptionLabel={getOptionLabel}
      value={value || []}
      onChange={(_, newValue) => {
        onChange(newValue);
      }}
      onInputChange={(_, inputValue) => {
        onInputChange?.(inputValue);
      }}
      isOptionEqualToValue={isOptionEqualToValue}
      loading={loading}
      slots={{
        paper: Paper,
      }}
      slotProps={{
        paper: {
          sx: paperStyles,
        },
        listbox: {
          sx: listboxStyles,
        },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder}
          variant="outlined"
          size="small"
          sx={inputStyles}
        />
      )}
      renderValue={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <SelectorChip
            key={option.id}
            option={option}
            getTagProps={getTagProps}
            index={index}
            getOptionLabel={getOptionLabel}
          />
        ))
      }
      noOptionsText={noOptionsText}
      loadingText={loadingText}
      renderOption={(props, option) => {
        const isSelected = value.some((item) => item.id === option.id);

        return (
          <SelectorOptionItem
            key={option.id}
            option={option}
            isSelected={isSelected}
            getOptionLabel={getOptionLabel}
            props={props}
          />
        );
      }}
    />
  );
};
